import type { FilesApi } from '@odo/shared-ui';
import api from '../api/config';
import {
    fetchCloudFileDownloadUrl,
    fetchFileViaProxy,
    updateCloudFile,
    uploadFileToGCS
} from './patientFiles';

/**
 * files-viewer implementation of the shared files module's IO seam, backed by
 * the app's authenticated axios client (see services/patientFiles for the
 * underlying endpoint wrappers).
 */
export const filesApi: FilesApi = {
    getDownloadUrl: (patientId, patientFileId) =>
        fetchCloudFileDownloadUrl(patientId, patientFileId),
    deleteFile: async (patientId, patientFileId) => {
        await api.delete(`/patients/${patientId}/cloud-files/${patientFileId}`);
    },
    updateFile: (patientId, patientFileId, changes) =>
        updateCloudFile(patientId, patientFileId, changes),
    uploadFile: (patientId, file, options) =>
        uploadFileToGCS(patientId, file, options?.onProgress, options?.metadata, options?.fileType),
    fetchViaProxy: (url, filename) => fetchFileViaProxy(url, filename)
};
